import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=958d8a10&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=958d8a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958d8a10",
  null
  
)

export default component.exports